module.exports = __webpack_public_path__ + "static/media/ic-view-regulation.12d44d3a.svg";